<template lang="html">
  <div class="app">
    <m-header></m-header>
    <keep-alive>
      <router-view/>
    </keep-alive>
    <p-review></p-review>
  </div>
</template>

<script>
import MHeader from 'components/ter/header/header'
import PReview from 'base/preview/preview'
export default {
  components: {
    MHeader,
    PReview
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.app
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
</style>



// WEBPACK FOOTER //
// src/components/ter/tIndex/tIndex.vue